export default __webpack_public_path__ + "static/media/drivers-license.be2738a0.svg";